export enum LoadingState {
  Idle,
  Loading,
  Loaded,
  Error,
}
